import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Tap2GOTicketTicketStatus } from 'meta/pages/goodsandservices'
import { initialState } from 'store/pages/ticket/state'

import { getBulkData } from '../actions/getBulkData'
import { getData } from '../actions/getData'

export const TicketSlice = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    setTicketAsChecked: (state, action: PayloadAction<{ code: string; checkedAt: string }>) => {
      const { code, checkedAt } = action.payload

      state.tickets[code] = {
        ...state.tickets[code],
        status: {
          key: Tap2GOTicketTicketStatus.checked,
          value: 1,
          label: 'Checked',
        },
        events: [
          {
            eventId: 0,
            status: {
              key: Tap2GOTicketTicketStatus.checked,
              value: 1,
              label: 'Checked',
            },
            entryDateTime: {
              date: checkedAt,
              date_tz: checkedAt,
              date_utc: checkedAt,
            },
          },
        ],
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      const ticket = action.payload
      state.tickets[ticket.cod] = ticket
    })
    builder.addCase(getBulkData.fulfilled, (state, action) => {
      action.payload.forEach((ticket) => (state.tickets[ticket.cod] = ticket))
    })
  },
})
